module.exports = __webpack_public_path__ + "img/icon_dropdown_select.4067071.png";